<template>
    <div class="homepage">
        <div v-for="(slide, index) in slides" :key="index" :class="slideClasses(index)">
            <background-image type="jpg" :alt-image="slide.alternativeText" :name-image="`homepage/homepage_${index}`" :style="getSlidePosition(index)">
                <div class="slide-content">

                    <div class="slide-content__title" v-if="index === 0">
                        <h2>{{slide.subtitle}}</h2>
                        <h1>{{slide.title}}</h1>
                        <h3>{{slide.text}}</h3>

                        <button @click="$store.commit('homePage/next')">
                            <span>></span>
                        </button>
                    </div>

                    <div v-else :class="slideDescriptionClasses(index)" >
                        <span>.</span>
                        <span class="index">{{index}}</span>
                        <span>.</span>

                        <button class="show-details" @click="$store.commit('homePage/showDetails')" :disabled="slide.showDetails">
                            {{slide.title}}

                            <span class="show-details__line">&shy;</span>
                        </button>
                        <p :class="slide.showDetails ? 'active' : ''">{{slide.details}}</p>
                    </div>

                </div>
            </background-image>
        </div>
    </div>
</template>

<script>
import checkDevice from "@/mixins/checkDevice";
import BackgroundImage from '@/components/elements/BackgroundImage'

export default {
    components: {BackgroundImage},
    name: 'Home',
    computed: {
        activeSlide: {
            get () {
                return this.$store.state.homePage.activeSlide
            },

            set (newValue) {
                return newValue
            }
        },
        prevActiveSlide: {
            get () {
                return this.$store.state.homePage.prevActive
            },

            set (newValue) {
                return newValue
            }
        },
        slides: {
            get () {
                return this.$store.state.homePage.slides
            },

            set (newValue) {
                return newValue
            }
        },
    },
    created: function () {
        this.isDesktopDevice = this.getDeviceName(screen) === 'desktop'
        window.addEventListener('resize', this.onResize)
    },
    data: () => ({
        isDesktopDevice: false,
    }),
    destroyed: function () {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        /**
         * Returns the top position of a slide according to the active slide.
         *
         * @param slideIndex: (number) The index of the slide
         */
        getSlidePosition: function(slideIndex){
            const topPercentage = (slideIndex - this.activeSlide) * 100

            if (this.isDesktopDevice) {
                return {top: `${topPercentage}%`}
            }

            return {}
        },
        /**
         * When user resize the screen, it check if device is the same,
         * otherwise some rules will change
         */
        onResize: function () {
            this.isDesktopDevice = this.getDeviceName(screen) === 'desktop'

            if (this.getDeviceName(screen) !== 'mobile'){
                this.$store.commit('slide/setProgress', this.activeSlide)
            }
        },
        /**
         * Returns classes for the slide.
         *
         * @param slideIndex: (number) The index of the slide
         */
        slideClasses: function (slideIndex) {
            return {
                'homepage__slide': true,
                'homepage__slide--hidden': !this.isDesktopDevice && slideIndex !== this.activeSlide,
            }
        },
        /**
         * Returns classes for the slide description.
         *
         * @param slideIndex: (number) The index of the slide
         */
        slideDescriptionClasses: function (slideIndex) {
            return {
                'active--down': this.isDesktopDevice && slideIndex === this.activeSlide && this.prevActiveSlide < slideIndex,
                'active--up': this.isDesktopDevice && slideIndex === this.activeSlide && this.prevActiveSlide > slideIndex,
                'hidden--down': this.isDesktopDevice && slideIndex < this.activeSlide,
                'hidden--up': this.isDesktopDevice && slideIndex > this.activeSlide,
                'slide-content__description': true,
            }
        },
    },
    mixins: [ checkDevice ],
}
</script>

<style lang="scss">
    @import './home.scss';
</style>
